import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'batchesOverview.title',
    defaultMessage: 'Batches',
    description: 'Title of the batches page',
  },
  primaryAction: {
    label: {
      id: 'batchesOverview.primaryAction.label',
      defaultMessage: 'Create',
      description: 'Label of the primary action on the batches page',
    },
  },
};

export default defineMessages(translations);
